import { AudioLines } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const AudioLinesIcon = createLucideIcon(AudioLines);
